import React, { Component } from 'react';
import { Popover, Progress } from 'antd';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as portalactions from '../../redux/portal';

class ImportProgressBall extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   showContent: false
    // }
  }

  // showContent(visible) {
  //   this.setState({ showContent: visible });
  // }

  getContent(asyncImportArr) {
    let totalCount = 0;
    let count = 0;
    let content = [];
    let itemsTitle = "正在处理";
    let lastUpdateTime = 0;
    Object.values(asyncImportArr).forEach(ele => {
      let asyncData = JSON.parse(ele.asyncData);
      if (ele.itemsTitle && ele.lastUpdateTime) {
        if (ele.lastUpdateTime > lastUpdateTime) {
          itemsTitle = ele.itemsTitle;
          lastUpdateTime = ele.lastUpdateTime;
        }
      }
      totalCount = totalCount + (asyncData.totalCount || 0);
      count = count + (asyncData.count || 0);
      let percentage = ele.percentage || 0;
      content.push(<div className="ImportProgressBall_Item">
        <div className="ImportProgressBall_Progress">
          <Progress
            type="line"
            strokeColor={{
              '100%': '#108ee9',
              '0%': '#87d068',
            }}
            percent={percentage}
            showInfo={false}
            status={percentage >= 100 ? "success" : "active"}
          />
        </div>
        <div className="ImportProgressBall_Info">
          [<span className="ImportProgressBall_Info_busName">{ele.busName}</span>] <span className="ImportProgressBall_Info_Finish">完成</span><span className="ImportProgressBall_Info_Rate">{percentage.toFixed(0)}%</span>
        </div>
      </div>);
    });

    content = <div className="ImportProgressBall_Content">
      <div className="ImportProgressBall_Title">{itemsTitle}({Object.keys(asyncImportArr).length})</div>
      <div className="ImportProgressBall_Items">
        {content}
      </div>
    </div>;
    // let rate = (count * 100 / totalCount).toFixed(0);
    if (totalCount == 0) {
      totalCount = 100;
    }
    let rate = _.floor(count * 100 / totalCount);
    let obj = {
      content,
      rateInfo: { rate, totalCount, count }
    };
    return obj;
  }

  formatter = (percent, successPercent) => {
    return <div className="ImportProgressBall_Percent"><span className="ImportProgressBall_PercentNum">{percent}</span><span className="ImportProgressBall_Percent100">%</span></div>;
  }

  render() {
    let self = this;
    const { portal } = this.props;
    // let asyncImportArr = self.props.asyncImportArr;
    let asyncImportArr = portal.asyncImportArr;
    if (_.isEmpty(asyncImportArr)) {
      return null;
    }
    else {
      let obj = this.getContent(asyncImportArr);
      return <div className="ImportProgressBall_Outer" id="ImportProgressBall_OuterID">
        <div className="ImportProgressBall_Inner">
          <Popover
            content={obj.content}
            trigger={"click"}
            // visible={self.state.showContent}
            // onVisibleChange={(visible) => self.showContent(visible)}
            placement="left"
            overlayClassName="ImportProgressBall_Popover"
            getPopupContainer={(triggerNode) => { return document.getElementById('ImportProgressBall_OuterID') || document.body || triggerNode.parentNode }}
          >
            <div className="ImportProgressBall_Rate">
              <Progress
                type="circle"
                strokeColor={{
                  '100%': '#108ee9',
                  '0%': '#87d068',
                }}
                percent={obj.rateInfo.rate}
                format={self.formatter}
              />
            </div>
          </Popover>
        </div>
      </div>
    }
  }
}

function mapStateToProps(state) {
  return {
    portal: state.portal.toJS()
  }
}

function mapDispatchToProps(dispatch) {
  return {
    portalactions: bindActionCreators(portalactions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportProgressBall);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/portal/ImportProgressBall.jsx